import * as Yup from 'yup'

export const SchemaValidation = (t) => Yup.object().shape({
  name: Yup.string().required(t('required')),
  textColor: Yup.string().nullable(),
  backgroundColor: Yup.string().nullable(),
  company: Yup.string().required(t('required')),
  active: Yup.boolean().required(t('required')),
})